import type { WireEarnedAchievement } from './net/protocol';
import type { SoundEvent } from './audio/soundObserver';

export const ACHIEVEMENT_AWARD_CUE: SoundEvent = { sound: 'level-up', volume: 1 };

/** One fresh server award becomes one private notice and one local reward cue. */
export function presentAchievementAward(
  achievement: WireEarnedAchievement,
  deps: {
    notify: (achievement: WireEarnedAchievement) => void;
    play: (cue: SoundEvent) => void;
  },
): void {
  deps.notify(achievement);
  deps.play(ACHIEVEMENT_AWARD_CUE);
}
